// 操作 Tips パネルの開閉状態を localStorage に保存する。

const KEY = "refinement-canvas:tips:collapsed";

export function loadTipsCollapsed(): boolean {
  try {
    return window.localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function saveTipsCollapsed(collapsed: boolean): void {
  try {
    window.localStorage.setItem(KEY, collapsed ? "1" : "0");
  } catch {
    // ignore
  }
}
